// extracted by mini-css-extract-plugin
export default {"root":"AdminModule_root__722Sm","drawer":"AdminModule_drawer__C6sv0","app-content":"AdminModule_app-content__fRPRh","main":"AdminModule_main__AVhBF"};